<template>
  <div class="list-page-shell">
    <div v-if="$slots.actions" class="list-page-shell__toolbar">
      <div class="list-page-shell__actions">
        <slot name="actions" />
      </div>
    </div>

    <div v-if="$slots.filters" class="list-page-shell__filters">
      <slot name="filters" />
    </div>

    <el-card shadow="never" class="list-page-shell__card">
      <slot />
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'ListPageShell'
}
</script>

<style scoped>
.list-page-shell {
  padding: 20px 28px 36px;
}

.list-page-shell__toolbar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 14px;
}

.list-page-shell__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.list-page-shell__filters {
  margin-bottom: 16px;
  padding: 16px 18px;
  border-radius: 12px;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  box-shadow: var(--shadow-card);
}

.list-page-shell__card {
  overflow: hidden;
}

@media (max-width: 900px) {
  .list-page-shell {
    padding: 16px 16px 28px;
  }

  .list-page-shell__toolbar {
    justify-content: flex-start;
  }

  .list-page-shell__actions {
    justify-content: flex-start;
  }
}
</style>
